
import { Observable } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { StsConfigService } from './sts-config.service';


@Injectable()
export class StsHttpService {
  private baseurlStandalone = '/api/';  // URL to web API
  private baseurlIntegrated = '/WPAPI/Inter?wppxpath='; // /WPApi?=http://StsApiWidget/';  // URL to web API

  private url;
  private isProd = false;

  constructor (
    private httpClient: HttpClient,
    private config: StsConfigService) {
      this.isProd = config.isProduction();
      this.url =  config.isProduction() ?
                  this.baseurlIntegrated : this.baseurlStandalone;
  }

  public get<E>(url: string, options?, mapper?): Observable<E> {
    let encodedUrl = this.getProperUrl(url);
    return this.httpClient
      .get(encodedUrl)
      .pipe(
        map(json => {
          return mapper ? mapper(json) : json;
        }),
        catchError((errorRes: HttpErrorResponse) => {
          return throwError(errorRes.error || 'Server error');
        })
      );
  }

  public postRegular<E>(url: string, params = {}): Observable<E> {
    return this.httpClient
      .post<E>(this.getProperUrl(url), params)
      .pipe(
        catchError((errorRes: HttpErrorResponse) => {
          return throwError(errorRes.error || 'Server error');
        })
      );
  }

  public post<E>(url: string, body, options = {}, mapper = null): Observable<E> {
    return this.httpClient
      .post(this.getProperUrl(url), body, options)
      .pipe(
        map(json => {
          return mapper ? mapper(json) : json;
        }),
        catchError((errorRes: HttpErrorResponse) => {
          if (errorRes.status === 500 && errorRes.error !== null && errorRes.error.code === 401) {
            console.log('Unauthorized received from portal. Redirecting to signout page!');
            window.location.href = '/Account/MustAuthTimeout';
            return;
          }
          return throwError(errorRes.error || 'Server error');
        })
      );
  }

  private getProperUrl(url: string): string {
    if (!url) { return url; }
    const isP = this.config.isProduction();

    // for texts
    let reText = /api\/texts\//ig;
    if (reText.exec(url) != null) {
      if (isP) {
        url = url.split(reText)[1];
        const tmp = btoa(`http://CMSWidget/texts/${url}`);
        return `/WPApi/Inter?wppxpath=${tmp}`;
      } else {
        return `/api/stsNullJson`;
      }
    }

    reText = /api\/account\/login/ig;
    if (reText.exec(url) != null) {
      if (isP) {
        return `/account/login`;
      } else {
        return `/api/account/login`;
        // return `/api/account/loginError`;
      }
    }

    reText = /api\/account\/loginFromTool/ig;
    if (reText.exec(url) != null) {
      if (isP) {
        return `/account/loginFromTool`;
      } else {
        return `/api/stsNullJson`;
      }
    }


    // images
    let reImage = /\/images\//ig;
    if (reImage.exec(url) != null) {
      if (isP) {
        url = url.split(reImage)[1];
        const tmp = btoa(`http://CMSWidget/imageurl/${url}`);
        return `/WPApi/Inter?wppxpath=${tmp}`;
      } else {
        return `/api/StsImages`;
      }
    }

    // images
    reImage = /\/sts-json\//ig;
    if (reImage.exec(url) != null) {
      if (isP) {
        const tmp = btoa(`http://CMSWidget/${url}`);
        return `/WPApi/Inter?wppxpath=${tmp}`;
      } else {
        return url;
      }
    }

    if (url.match(/\/api\/reg\//ig) != null) {
      if (isP) {
        const tmp = btoa(`http://Ariel360RegWidget/${url}`);
        return `/WPApi/Inter?wppxpath=${tmp}`;
      }
    }

    // regular api
    if (url.match(/\/api\//ig) != null) {
      if (isP) {
        const tmp = btoa(`http://ArielSecurityWidget/${url}`);
        return `/WPApi/Inter?wppxpath=${tmp}`;
      }
    }

    return url;
  }

  private extractData(res: Response) {
    let body = res.json();
    return body.data || { };
  }

  private handleError (error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);
    return throwError(errMsg);
  }

}
